// Single source of truth for status labels + theme-aware colors.
// Colors reference semantic tokens (see src/index.css) so they adapt to
// light/dark automatically. `soft`/`fg` are Tailwind classes for pills;
// `bar`/`hex` expose the chart color variable for recharts.

// Reservation lifecycle
export const reservationStatus = {
  pending: {
    label: 'Pendente',
    pill: 'bg-status-pending-soft text-status-pending',
    chartVar: '--status-pending',
  },
  confirmed: {
    label: 'Confirmado',
    pill: 'bg-status-confirmed-soft text-status-confirmed',
    chartVar: '--status-confirmed',
  },
  completed: {
    label: 'Concluído',
    pill: 'bg-status-completed-soft text-status-completed',
    chartVar: '--status-completed',
  },
  canceled: {
    label: 'Cancelado',
    pill: 'bg-status-canceled-soft text-status-canceled',
    chartVar: '--status-canceled',
  },
};

export const getReservationStatus = (state) =>
  reservationStatus[state] || reservationStatus.pending;

// Takeaway order lifecycle (richer set, keeps icons in the component layer)
export const orderStatus = {
  pending: { label: 'Pendente', pill: 'bg-status-canceled-soft text-status-canceled', accent: 'canceled' },
  received: { label: 'Novo Pedido', pill: 'bg-accent-2/15 text-accent-2', accent: 'accent-2' },
  preparing: { label: 'A Preparar', pill: 'bg-brand-soft text-brand', accent: 'brand' },
  'ready-to-pickup': { label: 'Pronto p/ Levantamento', pill: 'bg-status-completed-soft text-status-completed', accent: 'completed' },
  'on-delivery': { label: 'Em Entrega', pill: 'bg-chart-6/15 text-chart-6', accent: 'chart-6' },
  completed: { label: 'Concluído', pill: 'bg-surface-2 text-muted', accent: 'muted' },
  cancelled: { label: 'Cancelado', pill: 'bg-status-canceled-soft text-status-canceled', accent: 'canceled' },
  refunded: { label: 'Reembolsado', pill: 'bg-status-pending-soft text-status-pending', accent: 'pending' },
};

export const getOrderStatus = (status) =>
  orderStatus[status] || { label: status, pill: 'bg-surface-2 text-muted', accent: 'muted' };

// Pedido de reembolso sinalizado pelo cliente na app.
//
// Bloco separado de propósito: isto **não** é um `app_status`. Uma encomenda
// pode estar concluída e ter um pedido de reembolso aberto ao mesmo tempo, e
// misturá-los perdia o estado da cozinha.
//
// As classes vão escritas por extenso. O Tailwind faz purge do que não
// encontra no código, portanto `bg-status-${x}-soft` desaparece do bundle e o
// aviso fica invisível — sem erro nenhum a assinalá-lo.
export const refundRequestStatus = {
  requested: {
    label: 'Pedido de reembolso',
    pill: 'bg-status-pending-soft text-status-pending',
  },
  resolved: {
    label: 'Reembolso tratado',
    pill: 'bg-status-completed-soft text-status-completed',
  },
  dismissed: {
    label: 'Pedido dispensado',
    pill: 'bg-surface-2 text-muted',
  },
};

// O que o cliente pediu, para a etiqueta a piscar no cartão. São conversas
// diferentes ao telefone: num cancelamento devolve-se tudo, num problema
// depois da entrega quase sempre só o que falhou.
export const refundRequestKind = {
  cancel: { label: 'Pedido de cancelamento', icon: '↩️' },
  problem: { label: 'Problema depois da entrega', icon: '⚠️' },
};

export const refundPreference = {
  voucher: 'Crédito na conta',
  bank: 'Dinheiro de volta',
};

export const getRefundRequestStatus = (status) => refundRequestStatus[status] || null;

// Ordered palette for categorical charts (reads live CSS var values).
export const CHART_VARS = ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5', '--chart-6'];
